// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../cache-deps/virtual-store/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-form[data-v-f3f0b8ac]{border-radius:.25rem;--tw-bg-opacity:1;background-color:rgba(255,255,255,var(--tw-bg-opacity));padding-left:2.5rem;padding-right:2.5rem;padding-top:1.25rem;padding-bottom:1.25rem;filter:drop-shadow(0 2px 8px rgba(0,0,0,.1))}", ""]);
// Exports
module.exports = exports;
